export default {
  common: {
    app_name: 'Smart IoT Platform',
    loading: 'Loading...',
    save: 'Save',
    saving: 'Saving',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    filters: 'Filters',
    resetFilters: 'Reset Filters',
    language: 'Language',
    logout: 'Log out',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    required_field: 'This field is required',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    view_all: 'View all',
    view: 'View',
    select: 'Select an option',
    profile: 'Profile',
    signOut: 'Sign out',
    details: 'Details',
    tryAgain: 'Try Again',
    create: 'Create',
    update: 'Update',
    refresh: 'Refresh',
    actions: 'Actions',
    sortBy: 'Sort By',
    sortDirection: 'Sort Direction',
    ascending: 'Ascending',
    descending: 'Descending',
    perPage: 'Per Page',
    dismiss: 'Dismiss',
    createTime: 'Created At',
    lastUpdate: 'Last Updated',
    all: 'All',
    previous: 'Previous',
    next: 'Next',
    quickActions: 'Quick Actions',
    somethingWentWrong: 'Something went wrong',
    showing: 'Showing',
    to: 'to',
    of: 'of',
    results: 'results',
    unexpectedError: 'An unexpected error occurred',
    hours: 'hours',
    other: 'Other',
    pagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      results: 'results',
      page: 'Page',
      nextPage: 'Next page',
      previousPage: 'Previous page'
    }
  },
  devices: {
    statusOnline: 'Online',
    statusOffline: 'Offline',
    refreshSuccess: 'Device list refreshed successfully',
    statusMaintenance: 'Maintenance',
    statistics: 'Device Statistics',
    lastChecked: 'Last checked:',
    backToDevices: 'Back to Devices',
    stats: {
      cpu: 'CPU',
      memory: 'Memory',
      swap: 'Swap',
      disk: 'Storage',
      temperature: 'Temperature',
      noStatistics: 'No statistics available',
      power: 'Power',
      powerGoodText: 'Good',
      powerBadText: 'Needs attention',
      network: 'Network',
      sdcardGoodText: 'Good',
      sdcardBadText: 'Needs attention',
    },
    management: 'Device Management',
    managementDescription: 'A list of all IoT devices in your network including their status and location.',
    addNew: 'Add New Device',
    createNew: 'Create New Device',
    createDescription: 'Add a new device to your IoT network with the following information.',
    edit: 'Edit Device',
    editDevice: 'Edit Device',
    editDescription: 'Edit device details and configuration.',
    name: 'Device Name',
    type: 'Device Type',
    location: 'Location',
    serialNumber: 'Serial Number',
    lastSeen: 'Last Seen',
    actions: 'Actions',
    descriptionHelp: 'Add additional information about this device, its purpose, or configuration.',
    noDevicesAvailable: 'No devices available',
    deviceNotFound: 'Device not found',
    deviceInformation: 'Device Information',
    deviceDetails: 'Detailed information about this device and its current status.',
    setOnline: 'Set Online',
    setOffline: 'Set Offline',
    basicDetails: 'Basic details and configuration',
    information: 'Device Information',
    selectType: 'Select type',
    selectStatus: 'Select status',
    typeTemperature: 'Temperature',
    typeHumidity: 'Humidity',
    typeLight: 'Light',
    typeMotion: 'Motion',
    typeSwitch: 'Switch',
    typeOther: 'Other',
    confirmDelete: 'Confirm Delete',
    deleteWarning: 'Are you sure you want to delete this device? This action cannot be undone.',
    title: 'Devices',
    description: 'Manage your IoT devices and their configurations',
    addDevice: 'Add Device',
    namePlaceholder: 'Enter device name',
    ipAddress: 'IP Address',
    ipAddressPlaceholder: 'Enter IP address (e.g. 192.168.1.100)',
    ipAddressHelp: 'The IP address where this device can be accessed on your network',
    ipAddressInvalid: 'Please enter a valid IP address',
    ipAddressRequired: 'IP address is required',
    ipAddressTooLong: 'IP address is too long',
    nameRequired: 'Device name is required',
    nameTooLong: 'Device name is too long',
    statusRequired: 'Status is required',
    statusInvalid: 'Invalid status value',
    statusInactive: 'Inactive',
    statusActive: 'Active',
    statusShutdown: 'Shutdown',
    statusInactiveDescription: 'Device is registered but not actively monitored',
    statusActiveDescription: 'Device is online and being monitored',
    statusShutdownDescription: 'Device is temporarily disabled',
    deviceInactive: 'This device is currently inactive',
    deviceInactiveDescription: 'Activate this device to enable monitoring and control',
    deviceShutdown: 'This device is shutdown',
    deviceShutdownDescription: 'This device has been temporarily disabled',
    noDevices: 'No devices',
    noDevicesDescription: 'Get started by adding your first IoT device',
    deactivate: 'Deactivate',
    activate: 'Activate',
    addDeviceDescription: 'Add a new device to your IoT network',
    editDeviceDescription: 'Modify the settings for this device',
    deleteDevice: 'Delete Device',
    deleteConfirmation: 'Are you sure you want to delete {name}? This action cannot be undone.',
    statusUnknown: 'Unknown',
    refreshDevices: 'Refresh Devices',
    create: {
      title: 'Create New Device',
      error: 'Failed to create device'
    },
    fields: {
      name: 'Device Name',
      ipAddress: 'IP Address',
      status: 'Status'
    },
    status: {
      title: 'Status',
      inactive: 'Inactive',
      active: 'Active',
      shutdown: 'Shutdown'
    },
    schedules: {
      title: 'Component Schedules',
      description: 'Manage schedules for this component',
      add: 'Add Schedule',
      edit: 'Edit Schedule',
      delete: 'Delete Schedule',
      confirmDelete: 'Are you sure you want to delete this schedule?',
      addSuccess: 'Schedule added successfully',
      updateSuccess: 'Schedule updated successfully',
      deleteSuccess: 'Schedule deleted successfully',
      saving: 'Saving...',
      deleting: 'Deleting...',
      humanReadable: 'Human-readable description',
      activeLabel: 'Active',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      cronRequired: 'Cron expression is required',
      actionDataRequired: 'Action data is required',
      invalidCron: 'Invalid cron expression',
      invalidActionData: 'Invalid action data (must be valid JSON)',
      nameLabel: 'Name (optional)',
      namePlaceholder: 'Schedule name',
      scheduleType: 'Schedule Type',
      dailyTime: 'Daily Time',
      timeLabel: 'Time',
      actionLabel: 'Action',
      actionPlaceholder: 'Action to perform',
      deleteSchedule: 'Delete Schedule',
      deleteConfirmation: 'Are you sure you want to delete this schedule? This action cannot be undone.',
      cronFormat: 'Format: minute hour day-of-month month day-of-week',
      addNewSchedule: 'Add New Schedule',
      editSchedule: 'Edit Schedule',
      noSchedules: 'No schedules',
      getStarted: 'Get started by creating a new schedule.',
      cronTooComplex: 'This cron expression is too complex for daily time',
      stateSources: {
        schedule: 'Scheduled',
        manual: 'Manual Override',
        default: 'Default'
      },
      nextScheduleAt: 'Next scheduled change at:',
      noScheduleFound: 'No upcoming scheduled changes',
      currentState: 'Current State',
      stateSource: 'State Source',
      manualOverrideUntil: 'Manual Override Until',
      nextScheduleTime: 'Next Schedule',
      currentStateData: 'Current State Data',
      override: {
        title: 'Manual Override',
        apply: 'Apply Override',
        change: 'Change Override',
        remove: 'Remove Override',
        applying: 'Applying...',
        removing: 'Removing...',
        success: 'Override applied successfully',
        removeSuccess: 'Override removed successfully',
        duration: 'Duration',
        selectDuration: 'Select duration',
        untilDateTime: 'Until date/time',
        selectDateTime: 'Select date and time',
        overrideData: 'Override data',
        overrideDataPlaceholder: 'Enter JSON data',
        invalidData: 'Invalid JSON data',
        dataRequired: 'Override data is required',
        overrideActive: 'Manual override active',
        overrideExpires: 'Override expires:',
        confirmRemove: 'Are you sure you want to remove the current override?',
        types: {
          until_next_schedule: 'Until Next Schedule',
          duration: 'For a Duration',
          until_time: 'Until Specific Time',
          permanent: 'Permanent (Until Manually Removed)'
        }
      }
    }
  },
  readings: {
    temperature: 'Temperature',
    humidity: 'Humidity',
    pressure: 'Pressure',
    motion: 'Motion',
    light: 'Light',
    battery: 'Battery',
    lastReading: 'Last Reading',
    recentReadings: 'Recent Readings',
    unit: 'Unit',
    value: 'Value',
    timestamp: 'Timestamp',
    noReadingsAvailable: 'No readings available'
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome',
    activeDevices: 'Active Devices',
    totalReadings: 'Total Readings',
    deviceStatus: 'Device Status',
    sensorReadings: 'Sensor Readings (Last 7 Days)',
    noDevicesAvailable: 'No devices available',
    noReadingsAvailable: 'No readings available',
    description: 'Overview of your IoT network and device status',
    coming_soon: 'Dashboard features coming soon'
  },
  home: {
    hero: {
      title: 'Smart IoT Platform for Device Management',
      subtitle: 'Monitor and control your IoT devices with real-time data visualization and intelligent automation features.',
      getStarted: 'Get Started Free',
      login: 'Log In'
    },
    features: {
      title: 'Why Choose Our IoT Platform',
      subtitle: 'Our platform provides everything you need to manage and monitor your IoT devices effectively.',
      realTimeTracking: {
        title: 'Real-Time Monitoring',
        description: 'Stay updated with real-time data from all your connected devices and sensors with instant notifications.'
      },
      transactionHistory: {
        title: 'Smart Automation',
        description: 'Create custom rules and automation workflows to control your devices based on sensor data and schedules.'
      },
      portfolioAnalytics: {
        title: 'Data Analytics',
        description: 'Gain valuable insights from your device data with comprehensive analytics and customizable dashboards.'
      }
    },
    deviceTypes: {
      title: 'Supported Devices',
      subtitle: 'Our platform works with a wide range of IoT devices and sensors for various applications.',
      deviceType: 'Device Type',
      connectivity: 'Connectivity',
      applications: 'Applications',
      getStartedCta: 'Get Started with Your Devices'
    },
    howItWorks: {
      title: 'How It Works',
      subtitle: 'Get started with our IoT platform in just a few simple steps',
      step1: {
        title: 'Create Account',
        description: 'Sign up for a free account with just your email and password to get started.'
      },
      step2: {
        title: 'Connect Devices',
        description: 'Add your compatible IoT devices and sensors to the platform with our simple setup wizard.'
      },
      step3: {
        title: 'Configure Settings',
        description: 'Set up custom monitoring parameters and alerts based on your specific requirements.'
      },
      step4: {
        title: 'Monitor & Control',
        description: 'Access your personalized dashboard to view real-time data and control your connected devices.'
      }
    },
    cta: {
      title: 'Ready to Automate and Optimize Your IoT Environment?',
      subtitle: 'Join thousands of users who trust our platform to manage their IoT devices and create smarter environments.',
      createAccount: 'Create Free Account',
      signIn: 'Sign In'
    },
    footer: {
      description: 'Smart IoT platform for monitoring and controlling your connected devices with real-time data visualization.',
      quickLinks: 'Quick Links',
      resources: 'Resources',
      documentation: 'Documentation',
      api: 'API Reference',
      support: 'Support',
      contact: 'Contact',
      email: "nguyenductoan2405{'@'}gmail.com",
      phone: '(+84) 987 802 175',
      copyright: 'All rights reserved.'
    }
  },
  auth: {
    login: 'Login',
    register: 'Register',
    username: 'Username',
    password: 'Password',
    confirm_password: 'Confirm Password',
    name: 'Full Name',
    forgot_password: 'Forgot Password?',
    no_account: 'Don\'t have an account?',
    has_account: 'Already have an account?',
    create_account: 'Create Account',
    invalid_credentials: 'Invalid username or password',
    logout_success: 'You have been logged out successfully',
    password_mismatch: 'Passwords do not match',
    registration_success: 'Registration successful! You can now log in.',
    remember_me: 'Remember me',
    password_requirements: 'Password must be at least 6 characters long'
  },
  profile: {
    title: 'Profile',
    personal_info: 'Personal Information',
    change_password: 'Change Password',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm New Password',
    update_profile: 'Update Profile',
    update_password: 'Update Password',
    profile_updated: 'Profile updated successfully',
    password_updated: 'Password updated successfully',
    incorrect_password: 'Current password is incorrect',
    password_must_be_different: 'New password must be different from current password'
  },
  errors: {
    something_went_wrong: 'Something went wrong',
    network_error: 'Network error. Please check your connection and try again.',
    unauthorized: 'You are not authorized to access this resource',
    session_expired: 'Your session has expired. Please log in again.',
    validation_error: 'Please check the form for errors',
    not_found: 'The requested resource was not found'
  },
  languages: {
    en: 'English',
    vi: 'Vietnamese'
  },
  components: {
    management: 'Component Management',
    forDevice: 'Components for',
    viewAll: 'View All Components',
    clickToViewAll: 'Click to view all components for this device',
    manageComponents: 'Manage device components and their configurations',
    data: 'Data',
    details: 'Component Details',
    id: 'Component ID',
    deviceId: 'Device ID',
    backToComponents: 'Back to components',
    unableToDisplay: 'Unable to display component',
    loadingError: 'There was a problem loading the component data. Please try refreshing the page.',
    title: 'Components',
    addComponent: 'Add Component',
    editComponent: 'Edit Component',
    deleteComponent: 'Delete Component',
    deleteConfirmation: 'Are you sure you want to delete this component? This action cannot be undone.',
    addComponentDescription: 'Add a new component to this device.',
    editComponentDescription: 'Update component information and settings.',
    noComponents: 'No components found',
    noComponentsDescription: 'Add components to this device to monitor and control different functionalities.',
    type: 'Component Type',
    relay: 'Relay',
    sensor: 'Sensor',
    camera: 'Camera',
    typePlaceholder: 'Select component type',
    typeRequired: 'Component type is required',
    status: 'Status',
    lastData: 'Last Data',
    noData: 'No data available',
    dataNotAvailable: 'Data not available',
    relayState: {
      on: 'ON',
      off: 'OFF'
    },
    schedules: {
      title: 'Component Schedules',
      description: 'Manage automated schedules for this component',
      addSchedule: 'Add Schedule',
      editSchedule: 'Edit Schedule',
      cronExpression: 'Cron Expression',
      cronExpressionHelp: 'Schedule timing using cron syntax (e.g. * * * * *)',
      actionData: 'Action Data',
      actionDataHelp: 'JSON data representing the action to perform',
      priority: 'Priority',
      priorityHelp: 'Higher priority schedules take precedence when multiple schedules trigger simultaneously',
      isActive: 'Active',
      nextRun: 'Next Run',
      humanReadableCron: 'Schedule Description',
      noSchedulesFound: 'No schedules found for this component',
      addScheduleDescription: 'Create a new automated schedule for this component',
      editScheduleDescription: 'Update the settings for this schedule',
      deleteScheduleConfirmation: 'Are you sure you want to delete this schedule? This action cannot be undone.',
      currentState: 'Current State',
      stateSource: 'State Source',
      manualOverrideUntil: 'Manual Override Until',
      nextScheduleTime: 'Next Scheduled Change',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      statusHelp: 'Schedule will only run if active',
      override: {
        title: 'Manual Override',
        description: 'Temporarily override the scheduled behavior of this component',
        apply: 'Apply Override',
        change: 'Change Override',
        remove: 'Remove Override',
        duration: 'Duration',
        durationHelp: 'How long the override should remain active',
        durationValue: 'Duration Value',
        durationUnit: 'Duration Unit',
        untilTime: 'Until Time',
        untilTimeHelp: 'The specific time when the override should expire',
        actionData: 'Override Data',
        actionDataHelp: 'JSON data representing the override state',
        confirmRemove: 'Are you sure you want to remove the current override?',
        activeOverride: 'Active Override',
        noActiveOverride: 'No active override',
        overrideApplied: 'Override applied successfully',
        overrideRemoved: 'Override removed successfully',
        durationUnits: {
          minutes: 'Minutes',
          hours: 'Hours',
          days: 'Days'
        },
        types: {
          until_next_schedule: 'Until Next Schedule',
          duration: 'For a Duration',
          until_time: 'Until Specific Time',
          permanent: 'Permanent (Until Manually Removed)'
        }
      }
    }
  }
}